import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SectionTitle from './SectionTitle';
import mapImage from '../../../../images/features/saga/map.png';
import Typography from './StyledTypography';
import Grid from '@material-ui/core/Grid';
import SectionContainer from './SectionContainer';

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(8),
  },
  content: {
    marginTop: theme.spacing(2),
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row-reverse',
    },
  },
  mapImage: {
    width: '100%',
    margin: theme.spacing(3, 0),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(0),
    },
  },
  text: {
    marginBottom: theme.spacing(2),
  },
}));

const WhatsSaga = () => {
  const classes = useStyles();
  return (
    <SectionContainer>
      <SectionTitle subtitle="WHAT'S SAGA?" title="佐賀県ってどんなところ？" />
      <Grid container spacing={3} className={classes.content}>
        <Grid item xs={12} sm={6}>
          <img src={mapImage} alt="佐賀の地図" className={classes.mapImage} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography>
            九州北部にある佐賀は、東は福岡県、西は長崎県に接しています。
          </Typography>
          <Typography className={classes.text}>
            北は玄海国定公園に指定された風光明媚な海岸線を誇る玄界灘に面し、南には最大干満差6ｍの広大な干潟の広がる有明海に接した肥沃な佐賀平野が広がっています。
          </Typography>
          <Typography className={classes.text}>
            世界的に有名な陶磁器、豊かな自然に囲まれて育まれた海や山の幸、のんびりとくつろげる温泉やお祭りなどの歴史的な伝統ある豊かな文化といった魅力的な見どころがたくさんあります。
          </Typography>
          <Typography>
            以下の4つのエリアに分けて、もっと佐賀県が好きになる魅力をご紹介いたします。
          </Typography>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

export default WhatsSaga;
